export const EVENTS_SCHEMA_VERSION = "0.50.0";
export const PAGE_VIEWS_SCHEMA_VERSION = "0.23.0";
